import React from 'react'
import { Button, Input } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { allowedUploadExtensions } from '../../../hooks/useLeadActions'
import { WidgetTRefs } from '../../../types/widget'
import useSiteMetadata from '../../../hooks/useSiteMetadata'
import { ResumeUploadButtonCallback } from '../../Buttons/ResumeUpload'
import { useBETelemetry } from '../../../hooks/useTelemetry'

type Props = {
  onChange: React.ChangeEventHandler<HTMLInputElement> | ResumeUploadButtonCallback
  resumeApiStatus: 'idle' | 'submitting' | 'error' | 'success'
}

export default function MobileUploadWidgetV2({ onChange, resumeApiStatus }: Props) {
  const { classes } = useStyles()
  const { t } = useTranslation()
  const { defaultResumeProduct } = useSiteMetadata()
  const telemetry = useBETelemetry()

  return (
    <Button
      variant="contained"
      component="label"
      className={classes.uploadButton}
      disabled={resumeApiStatus === 'submitting'}
    >
      <Input
        type="file"
        // @ts-ignore
        onChange={onChange}
        onClick={() => {
          telemetry.track({ event: 'try_upload_resume' })
        }}
        className={classes.input}
        inputProps={{
          accept: allowedUploadExtensions.join(', '),
        }}
      />

      {resumeApiStatus === 'submitting'
        ? t(`${WidgetTRefs.StatusModalTRef}.buttonState.loadingText`, {
            defaultResumeProduct,
          })
        : t(`${WidgetTRefs.StatusModalTRef}.buttonState.mobile.defaultTextV2`, {
            defaultResumeProduct,
          })}
    </Button>
  )
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  uploadButton: {
    background: theme.colors.blue[10] + ' !important',
    color: theme.colors.blue[50] + ' !important',
    width: '100%',
    '&.Mui-disabled': {
      '&&': {
        background: theme.colors.blue[200],
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        opacity: 1,
      },
    },
  },
  input: {
    display: 'none',
  },
}))
